import React from "react";

export default function HelpPage() {
    return (
        <>
            <div className="card mb-4">
                <div className="card-header py-3">
                    <h4>Aide</h4>
                </div>
                <div className="card-body">
                    <p>Bientôt disponible...</p>
                </div>
            </div>
        </>
    );
}